<template>
  <div class="register-page">
    <site-header />
    <page-banner
      :src="banner.src"
      :alt="banner.alt"
      :fill-left="banner.fillLeft"
      :fill-right="banner.fillRight"
      auto-height
    />
    <main class="register-page__main">
      <div class="core-container">
        <register-page-content />
      </div>
    </main>
    <site-footer />
  </div>
</template>

<script>
import SiteHeader from '@/components/home/SiteHeader.vue'
import SiteFooter from '@/components/home/SiteFooter.vue'
import PageBanner from '@/components/common/PageBanner.vue'
import RegisterPageContent from '@/components/register/RegisterPageContent.vue'
import { REGISTER_BANNER } from '@/constants/registerPage'

export default {
  name: 'TrademarkRegisterPage',
  components: {
    SiteHeader,
    SiteFooter,
    PageBanner,
    RegisterPageContent
  },
  data() {
    return {
      banner: REGISTER_BANNER
    }
  }
}
</script>

<style scoped>
.register-page {
  min-height: 100vh;
  background: var(--color-bg-main);
}

.register-page__main {
  padding-bottom: var(--space-xl);
}
</style>
